export enum TaskSource {
    MANUAL = 'Manual',
    AUTOMATED = 'Automated'
}
